var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('learning-page-hero',{attrs:{"id":_vm.id,"headline":_vm.computedHeadline,"subheadline":_vm.computedSubheadline,"cta":_vm.computedCta,"href":_vm.computedHref,"open-signup":_vm.openSignup}})}
var staticRenderFns = []

export { render, staticRenderFns }